import Swiper from 'swiper/bundle';
import Alpine from 'alpinejs'
import '../sass/main.scss';
import './exit-popup';
import './compare-popup';
import './header';
import './scroll-to-contact';

window.Swiper = Swiper;
window.Alpine = Alpine

Alpine.start()
